"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var SalesIntelligence = function (_a) {
    var size = _a.size, title = _a.title, theme = _a.theme, _b = _a.color, color = _b === void 0 ? utils_1.themeToColor(theme) : _b, svgProps = __rest(_a, ["size", "title", "theme", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', style: __assign({ color: color }, svgProps.style), viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "sales-intelligence-app-icon" },
            react_1.default.createElement("path", { d: "M8.40581 25.9276L5.84688 23.2098L16.249 13.4114L26.5466 23.2172L23.9727 25.9202L16.2351 18.5527L8.40581 25.9276Z", fill: "#00B2AE" }),
            react_1.default.createElement("path", { d: "M11.8126 14.9972C11.8126 12.5567 13.7987 10.5706 16.2393 10.5706C18.6798 10.5706 20.6659 12.5567 20.6659 14.9972C20.6659 15.1402 20.6585 15.282 20.6446 15.4218L23.6942 18.3071C24.1454 17.2948 24.3982 16.1748 24.3982 14.9962C24.3982 10.497 20.7374 6.83618 16.2382 6.83618C11.739 6.83618 8.07821 10.497 8.07821 14.9962C8.07821 16.1556 8.32248 17.2586 8.76088 18.258L11.8286 15.3684C11.8179 15.2458 11.8115 15.122 11.8115 14.9962L11.8126 14.9972Z", fill: "currentcolor" }))));
};
exports.default = SalesIntelligence;
